import React from 'react';
import {
	Container,
	Box,
	Grid,
	Paper,
	Divider,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Avatar,
	withStyles,
	TableCell,
} from '@material-ui/core';
import BodyText from './BodyText';
import TitleText from './TitleText';
import DashboardTable from './DashboardTable';
import DashboardTable2 from './DashboardTable2';
import { color, data } from '../../constants';
import ChangeLogoModal from './ChangeLogoModal';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import SummaryBox from '../summary-box/SummaryBox';
import { useSelector } from 'react-redux';
const tableHeaders = [
	'Type',
	'Order ID',
	'Depart From',
	'Journey To',
	'Order Date',
	'Journey Date',
	'Ticket Cost',
	'Status',
	'Details',
];
const tableHeaders2 = [
	'Type',
	'Transaction Date',
	'Transaction Amount',
	// 'Description',
	'Commission',
	'Markup',
	'Payment Type',
];
const StyledTableCell = withStyles((theme) => ({
	head: {
		fontWeight: 600,
		color: '#8C8C8C',
		padding: 3,
		fontSize: 18,
	},
	root: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
}))(TableCell);

const Das = () => {
	const { wallet, walletagent, transagent,bookinghistoryagent } = useSelector(
		(state) => state.user
	);
	const summ = [
		{
			title: 'Sales',
			subtitle: 'Total sales today',
			value: `Rs ${4000}`,
			percent: 0,
		},
		{
			title: 'Total Booking',
			subtitle: 'Total orders today',
			value: bookinghistoryagent&&bookinghistoryagent?.result?.flights?.length,
			percent: bookinghistoryagent&&bookinghistoryagent?.result?.flights?.length,
		},
		{
			title: 'Revenue',
			subtitle: 'Total revenue today',
			value: '$678',
			percent: 38,
		},
		{
			title: 'Visits',
			subtitle: 'Total visits today',
			value: '2345',
			percent: 55,
		},
	];

	return (
		<>
		<Grid container>
			<Grid item xs={2}></Grid>
			<Grid item xs={8}><Carousel autoPlay infiniteLoop>
				
                <div>
                    <img src='https://www.teahub.io/photos/full/96-965938_vector-template-travels-banner.jpg' />
                </div>
                <div>
                    <img src="https://swall.teahub.io/photos/small/335-3358644_travel-agency-background-hd.jpg" />
                </div>
                <div>
                    <img src="https://img.freepik.com/free-vector/editable-travel-banner-template-bloggers_53876-117857.jpg?t=st=1650372577~exp=1650373177~hmac=4de771478ba7ace282aac4bca255cb01161b954f7b3829850fd0156603701a75" />
                </div>
            </Carousel></Grid>
			<Grid item xs={2}></Grid>
		</Grid>
			
		</>
	);
};

export default Das;
